import { addDollarSign } from '$lib/util/util';
import { get } from 'svelte/store';
import { clanWarsSummary } from './store';

export const handleTweetClick = (clanName: string) => {
	const rewardPool = addDollarSign(get(clanWarsSummary).totalRewardPool, 0);
	window.open(
		`https://twitter.com/share?text=Just joined ${
			clanName || ''
		} in Polynomial Clan Wars! ⚔️ %0a%0aExcited to start trading and lead my clan to victory 🏆. %0a%0aJoin now in competing for ${rewardPool} in rewards🤺 %0aCheck now at 👇 &url=https://trade.polynomial.fi/clan-wars`,
		'_blank'
	);
};
